export const FLOORS = 9;
export const RTP = .98;
export const walletNames = Object.freeze({ coins: 'PCoins', cash: 'PCash', bonus: 'Bonus' });
export const DIFFICULTIES = Object.freeze({
  easy: Object.freeze({ label: 'Easy', columns: 4, safe: 3 }),
  medium: Object.freeze({ label: 'Medium', columns: 3, safe: 2 }),
  hard: Object.freeze({ label: 'Hard', columns: 2, safe: 1 }),
  expert: Object.freeze({ label: 'Expert', columns: 3, safe: 1 }),
  master: Object.freeze({ label: 'Master', columns: 4, safe: 1 }),
});
const difficultyValid = value => Object.hasOwn(DIFFICULTIES, value);
export function wagerCents(value) {
  if (!/^\d+(?:\.\d{1,2})?$/.test(String(value))) return null;
  const [whole, part = ''] = String(value).split('.');
  const cents = Number(whole) * 100 + Number(part.padEnd(2, '0'));
  return Number.isSafeInteger(cents) && cents >= 100 && cents <= 100000 ? cents : null;
}
export function validWager(value) {
  return Number.isSafeInteger(value) && value >= 100 && value <= 100000;
}
export function multiplierFraction(difficulty, floor) {
  if (!difficultyValid(difficulty) || !Number.isInteger(floor) || floor < 1 || floor > FLOORS) throw new Error('Choose a valid difficulty and floor.');
  const { columns, safe } = DIFFICULTIES[difficulty];
  // The edge is applied once to the return, not compounded at every floor.
  return { numerator: 98n * BigInt(columns) ** BigInt(floor), denominator: 100n * BigInt(safe) ** BigInt(floor) };
}
export function payoutCents(wager, difficulty, floor) {
  if (!validWager(wager)) throw new Error('Enter a wager from 1.00 to 1,000.00 with up to two decimals.');
  const { numerator, denominator } = multiplierFraction(difficulty, floor);
  const product = BigInt(wager) * numerator;
  // One exact rational calculation, then round half up to integer cents.
  const result = Number((product * 2n + denominator) / (denominator * 2n));
  if (!Number.isSafeInteger(result)) throw new Error('The return is outside the supported range.');
  return result;
}
export function floorTable(difficulty, wager = 1000) {
  if (!difficultyValid(difficulty)) return [];
  const config = DIFFICULTIES[difficulty], chance = config.safe / config.columns;
  return Array.from({ length: FLOORS }, (_, i) => {
    const floor = i + 1, fraction = multiplierFraction(difficulty, floor);
    const multiplier = Number(fraction.numerator) / Number(fraction.denominator);
    return { floor, multiplier, reach: chance ** floor, stepChance: chance, rtp: RTP,
      payout: validWager(wager) ? payoutCents(wager, difficulty, floor) : null };
  });
}
export function randomBelow(limit, source = globalThis.crypto) {
  if (!Number.isInteger(limit) || limit < 1 || limit > 4 || !source?.getRandomValues) throw new Error('Secure randomness is unavailable. Use a current browser.');
  const value = new Uint32Array(1), ceiling = Math.floor(4294967296 / limit) * limit;
  do { source.getRandomValues(value); } while (value[0] >= ceiling);
  return value[0] % limit;
}

export {cleanBalances, validReference} from '../blackjack/blackjackModel';
